import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=b9ed93a0&scoped=true&"
import script from "./certification.vue?vue&type=script&lang=js&"
export * from "./certification.vue?vue&type=script&lang=js&"
import style0 from "./certification.vue?vue&type=style&index=0&id=b9ed93a0&prod&scoped=true&lang=css&"
import style1 from "./certification.vue?vue&type=style&index=1&id=b9ed93a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ed93a0",
  null
  
)

export default component.exports